<!--<printheaderview [hasimage]="1">
</printheaderview>-->
<div class="">
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Sperm Source Details</label>
              <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->

            </div>

          </div>


          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                <!--<div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientId}}</label>
                  </div>
                </div>-->
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 margin-top-10 margin-bottom-10px">
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-familysubhead font-weight-bold">Source Details:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Source of Sperm:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{MaleSource}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Husband/Donor:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{SourceFrom}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Collection Date:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{ExtDate | date:'dd-MMM-yyyy'}})</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Collection Time:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{ExtTime | date:'hh:mm:ss'}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Storage Location:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{StorageLoc}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-familysubhead font-weight-bold">Analysis:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Date of Sample Collection:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{DateofsampleCollection | date:'dd-MMM-yyyy'}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Time of Sample Collection:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{TimeofsampleCollection | date:'hh:mm:ss'}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Volume(ml):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{Volume}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Count(mil/ml):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{Count}}</label>
              </div>
            </div>
          </div>
          <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-4">
        <label class="margin-bottom-0px font-family">Motile Sperm Motility(%):</label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left">{{MotileSpermMotility}}</label>
      </div>
    </div>
  </div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Total Motility(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{TotalMotility}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Progressive Motility(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{ProgressiveMotility}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Non-Progressive Motility(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{NonProgressiveMotility}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Immotile(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{Immotile}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Morphology(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{Morphology}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Cellular Debris(mil/ml):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{CellularDebris}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Method of Preparation:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{MethodofPreparation}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Incubation Time(In Min):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{IncubationTime}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12" hidden>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Motile Sperm Count(mil/ml):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{MotileSpermCount}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12" hidden>
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Motility(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{Motility}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">DFI(%):</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{DFI}}</label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Notes:</label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left">{{Notes}}</label>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<!--<printfooterview [Sign1]="Sign1" [Sign2]="Sign2"></printfooterview>-->
